import * as React from "react";
import { useTranslation, Trans, I18nextContext } from 'gatsby-plugin-react-i18next';
import './storelist.scss';
// Defining the <Greeting> component
export const StoreList = (props) => {
  const { t } = useTranslation();
  let storeList = t('storeList', { returnObjects: true });
  let hasbook = props.teaser ? t('showbookteaser') : t('showbook');
  const context = React.useContext(I18nextContext);
  let lang = context.language;
  let teaserSmall;
  if(lang !== 'ja' && props.teaser){
    teaserSmall = true;
  }
  return (
      <div className={`${teaserSmall ? 'storeList--small' : ''} storeList`}>
        <div className="storeList__aux">
          {
            storeList.map((store, i) => {
              let isOpened = store.opening === "false" || !store.opening ? true : false
              return (
                <div className="storeList__store" key={`store${i}`}>
                  <div className="storeList__scroll">
                    
                    <div className="storeList__cont">
                      <h3 className="storeList__storeName">{store.name}</h3>   
                      {/* <span className="storeList__pop">{store.type} </span>  */}
                      <div className="storeList__address">
                        <span className="i-pin"></span>
                        {
                          store.mapurl ?  
                          <a className="storeList__city" target="_blank" href={store.mapurl}><Trans>{store.city}</Trans></a> 
                          :
                          <span className="storeList__city"><Trans>{store.city}</Trans></span>

                        }
                         
                      </div> 
                    </div>
                    {
                      hasbook === 'true' &&
                        <div className="storeList__baa">
                          {
                              isOpened ? (
                                store.bookurl && 
                                <a href={`${t(store.bookurl)}`}className="storeList__cta"><Trans>book an appointment</Trans></a>
                                ) : (
                                  <div className="storeList__baaCont">
                                     
                                    <span className = "storeList__opening">{store.opening}</span>
                                    {store.bookurl && <a href={`${t(store.bookurl)}`} tabIndex ="-1" className="storeList__cta storeList__cta--disabled"><Trans>book an appointment</Trans></a>}
                                  </div>
                                 
                              )
                          }
                           
                        </div>
                       
                    }
                                 

                  </div>
                </div>
                
                )
            }) 
          }

        </div>
  
      </div>
        
    )
  }